// extracted by css-extract-rspack-plugin
export default {"compoundingContainer":"compoundingContainer-tEMiZ9","compoundingDetailsField":"compoundingDetailsField-jwpO6a","placeholderColor":"placeholderColor-f92i2I"};